import PropTypes from "prop-types";
import React, { Component } from "react";
import { Box } from "@mui/material";
import ResourcesView from "../../views/Resources";
import AddItemsModal from "../../views/Resources/AdminMode/AddItemsModal";
import AddResource from "../../views/Resources/AdminMode/AddResource";
import { connect } from "react-redux";
import * as resourcesActions from "../../redux/actions/learningCenter/resourcesActions";
import { bindActionCreators } from "redux";
import { Typography } from "@mui/material";
import { withTranslation } from "react-i18next";
import { buildResourceViewerRoute } from "../../routes/Routes";
import { push } from "connected-react-router";

class Resources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resourceSections: props.resourceSections,
      itemsDlgOpen: false
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resourceSections !== this.props.resourceSections &&
      !this.props.loading
    ) {
      this.setState({ resourceSections: this.props.resourceSections });
    }
  }

  handleAddResourceSection = sectionTitle => {
    this.props.actions.addResourceSection(sectionTitle);
  };

  openItemsDialog = section => {
    this.setState({
      itemsDlgOpen: true,
      selectedSection: section
    });
  };

  /**
   * Called when the Add Items dialog is closed.
   */
  closeItemsDialog = () => {
    this.setState({
      itemsDlgOpen: false
    });
  };

  handleViewItem = (sectionId, itemId) => {
    this.props.actions.push(
      buildResourceViewerRoute(this.props.currentApp, sectionId, itemId)
    );
  };

  handleEditSection = (sectionId, sectionName) => {
    this.props.actions.updateSection(sectionId, sectionName);
  };

  handleDeleteSection = sectionId => {
    this.props.actions.deleteSection(sectionId);
  };

  handleEditItem = (itemId, itemName, sectionId) => {
    this.props.actions.updateItem(itemId, itemName, sectionId);
  };

  handleDeleteItem = (sectionId, itemId) => {
    this.props.actions.deleteItem(sectionId, itemId);
  };

  handleMoveItem = (
    itemId,
    fromSectionId,
    toSectionId,
    placeAfterItemId,
    itemIndex,
    newIndex
  ) => {
    this.reorderItems(fromSectionId, toSectionId, itemIndex, newIndex);
    this.props.actions.moveItem(
      itemId,
      fromSectionId,
      toSectionId,
      placeAfterItemId
    );
  };

  handleMoveSection = (sectionId, placeAfter, index, newIndex) => {
    this.reorderSections(index, newIndex);
    this.props.actions.moveSection(sectionId, placeAfter);
  };

  reorderSections = (sectionIndex, newIndex) => {
    let sections = this.state.resourceSections.slice();
    const [removed] = sections.splice(sectionIndex, 1);
    sections.splice(newIndex, 0, removed);

    this.setState({ resourceSections: sections });
  };

  reorderItems = (oldSectionId, newSectionId, itemIndex, newIndex) => {
    let sections = this.state.resourceSections.slice();
    const [removed] = sections
      .find(x => x.id === oldSectionId)
      .items.splice(itemIndex, 1);
    sections
      .find(x => x.id === newSectionId)
      .items.splice(newIndex, 0, removed);

    this.setState({ resourceSections: sections });
  };

  render() {
    const { resourceSections, itemsDlgOpen, selectedSection } = this.state;
    const { user, t, LayoutComponent } = this.props;

    return (
      <LayoutComponent title={t("resources.title")}>
        <Box mt={4}>
          {!resourceSections || resourceSections.length === 0 ? (
            <Typography variant="subtitle1" color="textPrimary" mb={4}>
              {t("learningCenterResources.noResourcesMsg")}
            </Typography>
          ) : (
            <ResourcesView
              sections={resourceSections}
              onOpenAddItemsModal={this.openItemsDialog}
              onItemClick={this.handleViewItem}
              isAdmin={user.isAdmin}
              onEditItem={this.handleEditItem}
              onEditSection={this.handleEditSection}
              onDeleteItem={this.handleDeleteItem}
              onDeleteSection={this.handleDeleteSection}
              onMoveItem={this.handleMoveItem}
              onMoveSection={this.handleMoveSection}
            />
          )}
          {user.isAdmin && (
            <AddResource onAdd={this.handleAddResourceSection} />
          )}
          {user.isAdmin && (
            <AddItemsModal
              currentSectionId={selectedSection?.id}
              open={itemsDlgOpen}
              onClose={this.closeItemsDialog}
            />
          )}
        </Box>
      </LayoutComponent>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userState.user,
  resourceSections: state.resourcesState.resourceSections,
  loading: state.resourcesState.loading,
  error: state.resourcesState.error
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...resourcesActions, push }, dispatch)
});

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Resources)
);

Resources.propTypes = {
  LayoutComponent: PropTypes.func.isRequired,
  actions: PropTypes.any,
  /**
   * The list of resource sections
   */
  resourceSections: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The name of the resource section
       */
      name: PropTypes.string,
      /**
       * The resources within the resource section
       */
      items: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The name of the resource
           */
          name: PropTypes.string,

          /**
           * The type of the resource
           */
          type: PropTypes.string
        })
      )
    })
  )
};
